import { createStore } from 'satcheljs';
import { CalendarPublishingStore } from './schema/CalendarPublishingStore';

let initialCalendarPublishingStoreData: CalendarPublishingStore = {
    viewState: null,
};

export default createStore<CalendarPublishingStore>(
    'CalendarPublishingStore',
    initialCalendarPublishingStoreData
);
